import React from "react";
import Image from "next/legacy/image";
import HeroImage from "public/assets/kelas-live/hero-image.png";
import {
  HeroSection,
  HeroSectionContent,
  HeroSectionCTA,
  HeroSectionImageWrapper,
  HeroSectionTitle,
  HeroSectionWrapper,
  HeroSectionButtons
} from "./kelas-live-home-hero.styles";
import { TrialActivationModal } from "../trial-activation-modal/trial-activation-modal";
import { useTrialActivationModal } from "../trial-activation-modal/use-trial-activation";
import { useAuth } from "stores/auth/auth-context";

const KelasLiveHomeHero: React.FC = () => {
  const {
    user: { userData }
  } = useAuth();
  const { showTrialActivation, setShowTrialActivation } =
    useTrialActivationModal(userData?.primary_user?.access_token);

  return (
    <>
      <HeroSectionWrapper>
        <HeroSection>
          <HeroSectionContent>
            <HeroSectionTitle>
              Kelas Live. Guru Juara. Temen Ambis.
            </HeroSectionTitle>
            <HeroSectionButtons>
              <HeroSectionCTA isOutlined={false} href="/paket">
                Cek paket belajar
              </HeroSectionCTA>
              <HeroSectionCTA
                isOutlined={true}
                onClick={() => setShowTrialActivation.on()}
              >
                Coba gratis dulu
              </HeroSectionCTA>
            </HeroSectionButtons>
          </HeroSectionContent>
          <HeroSectionImageWrapper>
            <Image
              src={HeroImage}
              alt="CoLearn Ambis students posing"
              layout="responsive"
              sizes="(min-width: 1200px) 33vw, (min-width: 768px) 50vw, 90vw"
              width={1656}
              height={772}
              priority
              loading="eager"
            />
          </HeroSectionImageWrapper>
        </HeroSection>
      </HeroSectionWrapper>
      {showTrialActivation && (
        <TrialActivationModal onClose={() => setShowTrialActivation.off()} />
      )}
    </>
  );
};

export { KelasLiveHomeHero };
